import { IconStar } from '@leland-dev/leland-ui-library';
import { type FC } from 'react';

import { type BootcampReviewReviewFragment } from './__generated-gql-types__/BootcampReview.generated';

interface BootcampReviewProps {
  review: BootcampReviewReviewFragment;
}

export const BootcampReview: FC<BootcampReviewProps> = ({ review }) => {
  return (
    <div className="flex flex-1 gap-6 rounded-2xl border border-leland-gray-stroke/30 bg-zinc-900 p-6">
      <div className="flex flex-col gap-4">
        <div className="flex">
          {Array.from({ length: 5 }).map((_, index) => (
            <IconStar key={index} className="size-4 text-leland-white" />
          ))}
        </div>
        <h3 className="text-xl text-leland-white">
          &quot;{review.comment}&quot;
        </h3>
        <span className="text-lg text-leland-gray-stroke">
          {review.guestReviewer}
        </span>
      </div>
    </div>
  );
};
